import { render, staticRenderFns } from "./IconBold.vue?vue&type=template&id=7207c2fa"
import script from "./IconBold.vue?vue&type=script&lang=js"
export * from "./IconBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports